<template>
  <el-container>
    <el-aside width="250px">
      <el-row>
        <label>Código/Item Code</label>
        <br />
        <el-input
          placeholder="Insira o código da obra"
          v-model="code"
          clearable
        />
      </el-row>
      <el-row>
        <label>Categorias/Subjects</label>
        <br />
        <el-select
          v-model="tagIds"
          filterable
          clearable
          remote
          v-bind:placeholder="Tag"
          :remote-method="searchTags"
          :loading="loading"
          multiple
        >
          <el-option
            v-for="tag in tags"
            :key="tag._id.$oid"
            :label="tag.value"
            :value="tag._id.$oid"
          >
          </el-option>
        </el-select>
      </el-row>

      <el-row>
        <label>Título/Title</label>
        <el-input
          placeholder="Insira o titulo da obra"
          v-model="title"
          clearable
        />
      </el-row>
      <el-row>
        <label>Autor/Author</label>
        <el-input
          placeholder="Insira o autor da obra"
          v-model="author"
          clearable
        />
      </el-row>
      <el-row>
        <label>Ano de Publicação/Year of Publication</label>
        <el-date-picker
          type="year"
          placeholder="Escolha um ano"
          v-model="year"
          style="width: 100%"
        />
      </el-row>
      <el-row>
        <el-button style="width: 100%" type="primary" @click="changeFilter"
          >Pesquisar/Search</el-button
        >
      </el-row>
    </el-aside>
    <el-main>
      <el-row :gutter="20">
        <el-input
          v-model="query"
          placeholder="Escreva algo"
          prefix-icon="el-icon-search"
        />
      </el-row>
      <el-carousel :interval="4000" type="card" height="200px">
        <el-carousel-item
          v-for="item in recent"
          :key="item"
          @click="goToBook(item)"
        >
          <h3 class="medium">{{ item.title }}</h3>
        </el-carousel-item>
      </el-carousel>
      <infinite-scroll
        @infinite-scroll="loadDataFromServer"
        :noResult="complete"
        message=""
      >
        <el-row v-for="chunk in books" :key="chunk" :gutter="30">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
            v-for="book in chunk"
            :key="book.id"
          >
            <card :value="book" @click="goToBook(book)" />
          </el-col>
          <br />
        </el-row>
      </infinite-scroll>
    </el-main>
  </el-container>
</template>

<script>
import { searchBooks } from "../../services/book";
import { searchTags } from "../../services/tags";
import Card from "../../partials/Card.vue";
import InfiniteScroll from "infinite-loading-vue3";
export default {
  components: {
    Card,
    InfiniteScroll,
  },
  data() {
    return {
      title: "",
      author: "",
      currentPage: 1,
      code: "",
      query: "",
      books: [],
      year: null,
      recent: [1, 2, 3, 4],
      complete: false,
      tagFromRoute: this.$route.query.tag ? this.$route.query.tag : "",
      tagIds: [],
      tags: [],
    };
  },
  methods: {
    searchTags(query) {
      if (query) {
        var params = {};
        params.value = query;
        this.loading = true;
        searchTags(params).then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.tags = response.data;
          }
        });
        this.loading = false;
      }
    },
    async getAllTags() {
      const response = await searchTags();
      if (response.status === 200) {
        this.tags = response.data;
        if (this.tagFromRoute) {
          this.tagIds.push(this.tagFromRoute);
        }
      }
    },
    goToBook(book) {
      this.$router.push(`/books/${book._id.$oid}`);
    },
    chunkArray(array) {
      const chunkSize = 6;
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    },
    changeFilter() {
      this.currentPage = 1;
      this.books = [];
      this.findBooks();
    },
    getRecent() {
      const params = {
        per_page: 4,
      };
      searchBooks(params).then((response) => {
        this.recent = response.data.items;
      });
    },
    findBooks() {
      const params = {
        sort_by: "rating",
        order: "descending",
      };
      params.per_page = 18;
      params.page = this.currentPage;
      if (this.title) {
        params.title = this.title;
      }
      if (this.code) {
        params.code = this.code;
      }
      if (this.author) {
        params.author = this.author;
      }
      if (this.year) {
        params.year = this.year.getFullYear();
      }
      if (this.tagIds.length > 0) {
        params.tag_ids = this.tagIds.toString();
      }
      if (this.query) {
        params.query = this.query;
      }
      searchBooks(params).then((response) => {
        this.books = this.books.concat(this.chunkArray(response.data.items));
        this.complete = response.data.current_page >= response.data.pages;
      });
    },
    loadDataFromServer() {
      this.currentPage++;
      this.findBooks();
    },
  },
  async created() {
    await this.getAllTags();
    this.findBooks();
    this.getRecent();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-aside {
  background-color: #d3dce6;
  color: var(--el-text-color-primary);
  padding: 0.5%;
  top: 0;
  bottom: 0;
  /* line-height: 20px; */
}
.el-main {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
label {
  margin-bottom: 5px;
  margin-left: 3px;
}
.picture {
  display: table-cell;
  margin-right: 10px;
}
img {
  min-width: 100px;
  min-height: 100px;
  max-width: 300px;
  max-height: 300px;
}
.description {
  height: 100px;
  display: table-cell;
  padding: 20px;
  vertical-align: top;
}
p {
  margin-bottom: 10px;
}
</style>
